export default __webpack_public_path__ + "static/media/weight_loss.15006a3a.svg";